// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes slides {
    0% {
      transform: translateX(0);
      opacity:0;
    }
    90% {
      transform: translateX(-100%);
      opacity:1;
    }
    91%{
        opacity:0;
    }
    100% {
        transform: translateX(0);
        opacity:0;
    }
  }
  
  .speakers {
    overflow: hidden;
    padding: 30px 0;
    white-space: nowrap;
    position: relative;
  }
  
  .speakers:before,
  .speakers:after {
    position: absolute;
    top: 0;
    content: "";
    width: 50px;
    height: 100%;
    z-index: 2;
  }
  
  .speakers:before {
    left: 0;
    background: linear-gradient( to left, rgba(255, 255, 255, 0), rgb(0, 0, 0) );
  }
  
  .speakers:after {
    right: 0;
    background: linear-gradient( to right, rgba(255, 255, 255, 0), rgb(0, 0, 0) );
  }
  
  .speaker_items {
    display: inline-block;
    transition: all 2s ease;
    animation: 20s slides infinite linear;
  }
  
  .speakers:hover .speaker_items {
    animation-play-state: paused;
  }
  

  

  .logos {
    overflow: hidden;
    padding: 30px 0;
    white-space: nowrap;
    position: relative;
  }
  
  .logos:before,
  .logos:after {
    position: absolute;
    top: 0;
    content: "";
    width: 250px;
    height: 100%;
    z-index: 2;
  }
  
  .logos:before {
    left: 0;
    background: linear-gradient( to left, rgba(255, 255, 255, 0), rgb(0, 0, 0) );
  }
  
  .logos:after {
    right: 0;
    background: linear-gradient( to right, rgba(255, 255, 255, 0), rgb(0, 0, 0) );
  }
  
  .logo_items {
    display: inline-block;
    width: 124px;
    animation: 15s slides infinite linear;
  }
  
  .logos:hover .logo_items {
    animation-play-state: paused;
  }
  
  .logo_items img {
    height: 24px;
    margin-right: 20px; /* فاصله بین لوگوها */
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Partners.css"],"names":[],"mappings":"AAAA;IACI;MACE,wBAAwB;MACxB,SAAS;IACX;IACA;MACE,4BAA4B;MAC5B,SAAS;IACX;IACA;QACI,SAAS;IACb;IACA;QACI,wBAAwB;QACxB,SAAS;IACb;EACF;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,OAAO;IACP,4EAA4E;EAC9E;;EAEA;IACE,QAAQ;IACR,6EAA6E;EAC/E;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;IACvB,qCAAqC;EACvC;;EAEA;IACE,4BAA4B;EAC9B;;;;;EAKA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,OAAO;IACP,4EAA4E;EAC9E;;EAEA;IACE,QAAQ;IACR,6EAA6E;EAC/E;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,qCAAqC;EACvC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,YAAY;IACZ,kBAAkB,EAAE,qBAAqB;EAC3C","sourcesContent":["@keyframes slides {\n    0% {\n      transform: translateX(0);\n      opacity:0;\n    }\n    90% {\n      transform: translateX(-100%);\n      opacity:1;\n    }\n    91%{\n        opacity:0;\n    }\n    100% {\n        transform: translateX(0);\n        opacity:0;\n    }\n  }\n  \n  .speakers {\n    overflow: hidden;\n    padding: 30px 0;\n    white-space: nowrap;\n    position: relative;\n  }\n  \n  .speakers:before,\n  .speakers:after {\n    position: absolute;\n    top: 0;\n    content: \"\";\n    width: 50px;\n    height: 100%;\n    z-index: 2;\n  }\n  \n  .speakers:before {\n    left: 0;\n    background: linear-gradient( to left, rgba(255, 255, 255, 0), rgb(0, 0, 0) );\n  }\n  \n  .speakers:after {\n    right: 0;\n    background: linear-gradient( to right, rgba(255, 255, 255, 0), rgb(0, 0, 0) );\n  }\n  \n  .speaker_items {\n    display: inline-block;\n    transition: all 2s ease;\n    animation: 20s slides infinite linear;\n  }\n  \n  .speakers:hover .speaker_items {\n    animation-play-state: paused;\n  }\n  \n\n  \n\n  .logos {\n    overflow: hidden;\n    padding: 30px 0;\n    white-space: nowrap;\n    position: relative;\n  }\n  \n  .logos:before,\n  .logos:after {\n    position: absolute;\n    top: 0;\n    content: \"\";\n    width: 250px;\n    height: 100%;\n    z-index: 2;\n  }\n  \n  .logos:before {\n    left: 0;\n    background: linear-gradient( to left, rgba(255, 255, 255, 0), rgb(0, 0, 0) );\n  }\n  \n  .logos:after {\n    right: 0;\n    background: linear-gradient( to right, rgba(255, 255, 255, 0), rgb(0, 0, 0) );\n  }\n  \n  .logo_items {\n    display: inline-block;\n    width: 124px;\n    animation: 15s slides infinite linear;\n  }\n  \n  .logos:hover .logo_items {\n    animation-play-state: paused;\n  }\n  \n  .logo_items img {\n    height: 24px;\n    margin-right: 20px; /* فاصله بین لوگوها */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
